import React, { useEffect, useState } from 'react';
import { useEHRContext } from 'contexts/EHRContext';
import {
  Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot,
} from '@material-ui/lab';
import { fixTimezoneOffset, monthNames } from 'utils/dateFunctions';
import '../TemplateTab/TemplateTab.css';
import { formatName, logDebug, retrieveData } from 'utils/AuxiliarFunctions';
import xdsToken from 'services/xdsToken';
import { currentMode, endpoints } from 'configs';
import axios from 'axios';
import { ToastMessage } from 'components';
import { toast } from 'react-toastify';
import { EmptyFieldWarning } from '../EmptyFieldWarning';
import { DocumentsVisualizer } from '../DocumentsVisualizer';
import { DocumentsCard } from '../DocumentsCard';
import { LoadMoreButton } from '../LoadMoreButton';

export function EventSummaryTimeline() {
  const {
    eventSummary,
    ehrState,
  } = useEHRContext();

  const [modalContent, setModalContent] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [paginationNextUrl, setPaginationNextUrl] = useState('');
  const [timelineList, setTimelineList] = useState([]);
  const [loadingMoreDocuments, setLoadingMoreDocuments] = useState(false);

  const slicedTable = timelineList;

  const dateCards = [];
  slicedTable.forEach((element) => {
    const isoDate = element.resource?.date || '';
    const month = monthNames[fixTimezoneOffset(new Date(isoDate)).getMonth() + 1];
    const year = fixTimezoneOffset(new Date(isoDate)).getFullYear();
    if (!dateCards.includes(`${month} - ${year}`)) dateCards.push(`${month} - ${year}`);
    else dateCards.push('');
  });

  async function getTokens() {
    await xdsToken.getBearerToken();
    const bearerToken = await retrieveData('application_token');
    const xUserToken = await retrieveData('token');
    return { bearerToken, xUserToken };
  }

  function handleUpdateTimeline() {
    try {
      if (paginationNextUrl) {
        setLoadingMoreDocuments(true);
        const link = `${endpoints.MHD}?${paginationNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${ehrState.subject.token || tokens.bearerToken}`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && { 'organization-id': ehrState.subject.organizationId }),
            ...(ehrState.resource.id && currentMode === 'aghu' && { 'resource-id': ehrState.resource.id }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get', url: link, headers, timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(<ToastMessage type="success"> Requisição completada.</ToastMessage>);
              setTimelineList([...timelineList, ...response.entry]);
              setPaginationNextUrl(response.link.find(({ relation }) => relation === 'next')?.url);
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(<ToastMessage type="error"> Requisição completada.</ToastMessage>);
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  useEffect(() => {
    if (Array.isArray(eventSummary?.link)) {
      setPaginationNextUrl(eventSummary?.link.length > 1 ? eventSummary?.link.find(
        ({ relation }) => relation === 'next',
      ).url : '');
    }
    if (Array.isArray(eventSummary?.entry)) setTimelineList(eventSummary?.entry);
  }, [eventSummary]);

  return (
    <>
      {slicedTable.length ? (
        <div className="documentsTab-containter">
          <div
            className="ehrTimeline-container"
          >
            <Timeline>
              {slicedTable.map((element, index) => {
                const auxDate = element.resource?.date || '';
                const auxType = element.resource?.type.coding[0].display || '';
                const auxPractitioner = element.resource?.contained?.find((identifier) => identifier.resourceType === 'Practitioner')?.name[0].text || 'Não encontrado';
                let auxPractitionerName = auxPractitioner?.name?.find(({ given }) => given)?.given;
                if (Array.isArray(auxPractitionerName)) auxPractitionerName = auxPractitionerName[0];

                const auxOrganization = element.resource?.contained?.find((identifier) => identifier.resourceType === 'Organization')?.alias[0];
                // const auxOrganizationId = auxOrganization.identifier[0].value;
                // const auxOrganizationAlias = auxOrganization.alias ? auxOrganization.alias[0] : auxOrganization.name || 'Não Encontrado';
                // const auxOrganizationName = auxOrganization && auxOrganization.name;
                const auxDocumentBinaryId = element.resource?.content[0].attachment?.url;
                const contentType = element.resource?.content[0]?.format?.code;
                return (
                  <>
                    {dateCards[index] && (
                      <TimelineItem key={`timelineDateItemCard-${dateCards[index]}`}>
                        <TimelineSeparator>
                          <TimelineDot className="highlight" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div className="ehrTimeline-dateCard">{dateCards[index]}</div>
                        </TimelineContent>
                      </TimelineItem>
                    )}
                    <TimelineItem key={`timelineItemCard-${element.resource.id}`}>
                      <TimelineSeparator>
                        <TimelineDot />
                        {index !== slicedTable.length - 1 && (<TimelineConnector />)}
                      </TimelineSeparator>
                      <TimelineContent>
                        <DocumentsCard
                          selectedIndex={selectedIndex}
                          index={index}
                          setSelectedIndex={setSelectedIndex}
                          setModalContent={setModalContent}
                          documentBinaryId={auxDocumentBinaryId}
                          date={auxDate || ''}
                          type={auxType}
                          contentType={contentType}
                          organizationName={auxOrganization}
                          binary={auxDocumentBinaryId}
                          description={`Profissional: ${formatName(auxPractitioner)}`}
                          alias={auxOrganization}
                        />
                      </TimelineContent>
                    </TimelineItem>
                  </>
                );
              })}
            </Timeline>
            {
              paginationNextUrl
              && <LoadMoreButton onClick={handleUpdateTimeline} />
            }
          </div>
          {
            modalContent.link
            && (
            <DocumentsVisualizer modalContent={modalContent} />
            )
          }

        </div>
      ) : <EmptyFieldWarning />}

    </>
  );
}
